import { motion, useTransform } from 'framer-motion';
import { TID } from '../lib/testIds';

// Deterministic positions so layout is stable across renders.
const PARTICLES = [
  { top: '16%', left: '10%', size: 5, layer: 2, dur: 6.5, delay: 0, color: '#D8FF3A' },
  { top: '28%', left: '22%', size: 3, layer: 0, dur: 5, delay: 0.6, color: '#D8FF3A' },
  { top: '42%', left: '15%', size: 4, layer: 1, dur: 7, delay: 1.1, color: '#9bd1ff' },
  { top: '20%', left: '38%', size: 2, layer: 0, dur: 4.5, delay: 0.3, color: '#D8FF3A' },
  { top: '60%', left: '30%', size: 6, layer: 2, dur: 8, delay: 1.5, color: '#D8FF3A' },
  { top: '34%', left: '52%', size: 3, layer: 1, dur: 6, delay: 0.9, color: '#D8FF3A' },
  { top: '70%', left: '46%', size: 2, layer: 0, dur: 5.5, delay: 0.2, color: '#9bd1ff' },
  { top: '24%', left: '64%', size: 4, layer: 2, dur: 7.5, delay: 1.2, color: '#D8FF3A' },
  { top: '52%', left: '72%', size: 3, layer: 1, dur: 6.2, delay: 0.5, color: '#D8FF3A' },
  { top: '38%', left: '84%', size: 5, layer: 2, dur: 8.5, delay: 1.8, color: '#D8FF3A' },
  { top: '66%', left: '88%', size: 2, layer: 0, dur: 4.8, delay: 0.7, color: '#9bd1ff' },
  { top: '12%', left: '78%', size: 3, layer: 1, dur: 6.8, delay: 1.0, color: '#D8FF3A' },
  { top: '76%', left: '18%', size: 3, layer: 1, dur: 7.2, delay: 0.4, color: '#D8FF3A' },
  { top: '48%', left: '6%', size: 2, layer: 0, dur: 5.2, delay: 1.3, color: '#D8FF3A' },
];

export default function HeroParticles({ progress }) {
  // Scroll-linked parallax: deeper layers drift further as you scroll near them.
  const y0 = useTransform(progress, [0, 1], [0, -90]);
  const y1 = useTransform(progress, [0, 1], [0, -190]);
  const y2 = useTransform(progress, [0, 1], [0, -320]);
  const fade = useTransform(progress, [0, 0.7, 1], [1, 0.5, 0]);
  const layers = [y0, y1, y2];

  return (
    <motion.div
      aria-hidden
      data-testid={TID.heroParticles}
      style={{ opacity: fade }}
      className="absolute inset-0 z-[5] pointer-events-none overflow-hidden"
    >
      {PARTICLES.map((p, i) => (
        <motion.div
          key={i}
          style={{ y: layers[p.layer], top: p.top, left: p.left }}
          className="absolute"
        >
          <motion.span
            className="block rounded-full"
            style={{
              width: p.size,
              height: p.size,
              background: p.color,
              boxShadow: `0 0 ${p.size * 3}px ${p.size}px ${p.color}66`,
            }}
            animate={{ y: [0, -16, 0], opacity: [0.25, 0.85, 0.25] }}
            transition={{ duration: p.dur, repeat: Infinity, ease: 'easeInOut', delay: p.delay }}
          />
        </motion.div>
      ))}
    </motion.div>
  );
}
